import { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import { getContract } from 'utils/web3'
import hyprABI from 'config/abi/hypr.json'
import useRefresh from './useRefresh'

const useHyprBurnRate = (hyprAddress: string) => {
  const [burnRate, setBurnRate] = useState(new BigNumber(0))
  const { fastRefresh } = useRefresh()

  useEffect(() => {
    const fetchBurnRate = async () => {
      const hyprContract = getContract(hyprABI, hyprAddress)
      const res = await hyprContract.methods.currentBurnPercent().call()
      setBurnRate(new BigNumber(res))
    }

    fetchBurnRate()
  }, [hyprAddress, fastRefresh])

  return burnRate
}

export default useHyprBurnRate
